app.controller('OrderCheckoutAcknowledgementController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    $scope.order_id = $stateParams.order_id ? $stateParams.order_id : $rootScope.model.order.current_order._id;

    $scope.waiting_for_data = !!$scope.order_id;

    $scope.visible_order = null;

    if ($scope.waiting_for_data) {
        $rootScope.service.account.requireMinimumData(function () {
            $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {
                console.log(order)

                $scope.visible_order = success ? order : null;
                $scope.waiting_for_data = false;

            })
        });
    }

}]);